var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "card mb-2 p-2" },
    [
      _c(
        "router-link",
        {
          staticClass: "text-center",
          attrs: { to: _vm.speakerUrl(_vm.speaker) },
        },
        [
          _c("favorite", {
            attrs: {
              attr: "speaker",
              value: _vm.speaker.content_code,
              obj: _vm.speaker,
            },
            on: {
              "favorite-changed": function ($event) {
                return _vm.$emit("favorite-changed", $event)
              },
            },
          }),
          _vm._v(" "),
          _c("img", {
            staticClass: "avatar",
            attrs: { src: _vm.speaker.profile_img_url },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "card-body text-center" }, [
            _c("h4", { staticClass: "card-title mb-0" }, [
              _vm._v(_vm._s(_vm.speakerFullName(_vm.speaker))),
            ]),
            _vm._v(" "),
            _vm.speaker.job_title
              ? _c("p", { staticClass: "text-muted" }, [
                  _c("small", [_vm._v(_vm._s(_vm.speaker.job_title))]),
                  _vm._v(" "),
                  _vm.speaker.sessions_chaired.length
                    ? _c("small", [_c("br"), _vm._v("Moderator:in")])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.speaker.company
              ? _c("div", [_vm._v(_vm._s(_vm.speaker.company))])
              : _vm._e(),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }